export var resultImgMissing = function() {
	if($('.result-list').length > 0){
		$('.result-list').on('error', 'img.product-img', function() {
	        $(this).attr('src', '//dimg.dillards.com/is/image/DillardsZoom/nav/error/missing-result-img.jpg');
	    });
	}else{
		$('img.product-img').on('error', function() {
	        $(this).attr('src', '//dimg.dillards.com/is/image/DillardsZoom/nav/error/missing-result-img.jpg');
	    });
	}
};
